import type { LocationQuery } from 'vue-router'
import type { RechercheQueryDTO } from '@/features/api/extranet/dto/Demande/Recherche'
import { useRechercheDemandeStore } from './useRechercheDemandeStore'
import { locationQueryValueToArray, parseBool, parseIntWithDefault } from '@/features/shared/tools'
import type { PagedRequest } from '../storeRechercheBuilder'
import { provideLoadRechercheService } from '../rechercheRoutingServiceProvider'
import { buildRechercheRoutingService } from '../rechercheRoutingServiceBuilder'

export function useRechercheDemandeRoutingService() {
  return buildRechercheRoutingService<RechercheQueryDTO>(useRechercheDemandeStore, parseLocationQuery)
}
provideLoadRechercheService('demande', useRechercheDemandeRoutingService)

function parseLocationQuery(query: LocationQuery): PagedRequest<RechercheQueryDTO> {
  const loadParams: PagedRequest<RechercheQueryDTO> = {
    query: {
      search: locationQueryValueToArray(query.search),
      estSousMandatGestion: parseBool(query.estSousMandatGestion as string),
      avecSubrogation: parseBool(query.avecSubrogation as string),
      statuts: locationQueryValueToArray(query.statuts, []) as any,
      dispositifs: locationQueryValueToArray(query.dispositifs, []) as any,
      periode: (query.periode as string) ?? '',
      dateDebut: (query.dateDebut as string) ?? '',
      dateFin: (query.dateFin as string) ?? '',
    },
    orderBy: locationQueryValueToArray(query.orderBy, [])!, // verifier
    pagination: {
      pageNumber: parseIntWithDefault(query.pageNumber as string, 1)!,
      pageSize: parseIntWithDefault(query.pageSize as string) as number | undefined,
    },
  }
  return loadParams
}

